module.exports = __webpack_public_path__ + "img/default.6266d901.svg";